import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllStudentsSelectOptionsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllStudentsSelectOptions
  implements GetAllStudentsSelectOptionsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllStudentsSelectOptionsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllStudentsSelectOptionsUseCaseInterface.Params,
  ): Promise<GetAllStudentsSelectOptionsUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, params);
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
